'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _listeners = require('../utils/listeners');

var _functional = require('../utils/functional');

var classes = {
  HIDE: 'util-Hide'
};

var init = function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var initialState = getInitialState(el);
  var els = getEls(el, initialState);
  var listeners = new _listeners.Listeners();

  listeners.add(el, 'click', function () {
    (0, _functional.copyToClipboard)(initialState.copyText);
    toggleSuccessMessage(true);
  });

  function toggleSuccessMessage(show) {
    els.successMessage.forEach(function (el) {
      el.classList.toggle(classes.HIDE, !show);
    });

    if (els.tooltipMessage.length > 0) {
      els.tooltipMessage.forEach(function (el) {
        el.classList.add(classes.HIDE);
      });

      setTimeout(function () {
        els.tooltipMessage.forEach(function (el) {
          el.classList.remove(classes.HIDE);
        });
      }, 1000);
    }

    setTimeout(function () {
      els.successMessage.forEach(function (el) {
        el.classList.add(classes.HIDE);
      });
    }, 1000);
  }
};

function getInitialState(el) {
  return {
    copyText: el.dataset.copyText,
    successMessageSelector: el.dataset.successMessageSelector,
    tooltipMessageSelector: el.dataset.tooltipMessageSelector
  };
}

function getEls(el, initialState) {
  return {
    copyText: el.dataset.copyText,
    successMessage: (0, _functional.getElements)(initialState.successMessageSelector),
    tooltipMessage: (0, _functional.getElements)(initialState.tooltipMessageSelector)
  };
}

exports.init = init;